"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rest = require("lodash/rest");
var factory_1 = require("./factory");
var applicators_1 = require("./applicators");
var decorator = factory_1.DecoratorFactory.createDecorator(new factory_1.DecoratorConfig(rest, new applicators_1.PreValueApplicator()));
function Rest(start) {
    return decorator(start);
}
exports.Rest = Rest;
exports.rest = Rest;
exports.default = decorator;
//# sourceMappingURL=rest.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_lodash-decorators@4.5.0@lodash-decorators/rest.js
// module id = j7WX
// module chunks = 0 1 3 4 5 6 7 8